import React, { useEffect, useState } from "react";
import { useUnit } from "effector-react";
import {} from "effector";
import {
  setPage,
  setSelectedMinutes,
  setFinalPrice,
  VacuumStore,
  restartInteraction,
} from "../../../../stores/VacuumStore/VacuumStore";
import { roundToTwo } from "../../../../utils/functions";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";
import PickTime from "./components/PickTime/PickTime";
import TotemOption from "../../components/TotemOption/TotemOption";
import { TimeOptionsContainer, TimeWrapper } from "./ChooseTimeStyles";

const timeOptions = [
  {
    type: "fixed",
    time: 5,
    price: 5.0,
    title: "5 minutos",
  },
  {
    type: "fixed",
    time: 7,
    price: 7.0,
    title: "7 minutos",
  },
  {
    type: "fixed",
    time: 10,
    price: 10.0,
    title: "10 minutos",
  },
  {
    type: "custom",
    time: 10,
    price: 10.0,
    title: "Escolher tempo",
  },
];

const ChooseTime: React.FC = () => {
  const { selectedMinutes, selectedVacuum, finalPrice } = useUnit(VacuumStore);

  const [currentTime, setTimeOption] = useState(timeOptions[2]);

  const isCustomSelection = currentTime.type === "custom";

  useEffect(() => {
    const minutes = currentTime?.time ?? 5;
    setSelectedMinutes(minutes);

    const vacPrice = selectedVacuum?.pricePerMinute ?? 0;
    const totalPrice = minutes * vacPrice;

    setFinalPrice(roundToTwo(totalPrice));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime]);

  const handleReturnSelection = () => {
    setTimeOption(timeOptions[2]);
  };

  const handleGoToStart = () => {
    setPage(PAGES.VACUUM_CHOICE);
  };

  const handleNextStep = () => {
    setPage(PAGES.VACUUM_PAYMENT);
  };
  const Buttons = (
    <>
      {isCustomSelection ? (
        <TotemButton
          negative
          onClick={() => handleReturnSelection()}
          text="Voltar"
        />
      ) : (
        <TotemButton
          negative
          onClick={() => handleGoToStart()}
          text="Cancelar"
        />
      )}
      <TotemButton onClick={() => handleNextStep()} text="Continuar" />
    </>
  );

  const renderOptions = () => {
    return timeOptions.map((option, index) => {
      const isselected = currentTime?.title === option?.title;
      const fixedPrice = option?.price?.toFixed(2).replace(".", ",");
      const priceText = option.type !== "custom" ? `R$ ${fixedPrice}` : "";

      return (
        <TotemOption
          key={`${option?.time}_${index}`}
          title={option.title}
          subtitle={priceText}
          isselected={isselected}
          execSelection={() => setTimeOption(option)}
        />
      );
    });
  };

  return (
    <TotemSkeleton title="Escolha o tempo" buttons={Buttons}>
      <TimeWrapper>
        {isCustomSelection ? (
          <PickTime
            selectedMinutes={selectedMinutes}
            selectedVacuum={selectedVacuum}
            finalPrice={finalPrice}
          />
        ) : (
          <TimeOptionsContainer>{renderOptions()}</TimeOptionsContainer>
        )}
      </TimeWrapper>
    </TotemSkeleton>
  );
};

export default ChooseTime;
